import { TxStatus } from "src/configs/constance";
import { popTxStatus, pushTxStatusThunk, updateTxStatus } from "src/redux/tx-status-slice";

export function handleEmit(dispatch, emit, type) {
  const id = dispatch(pushTxStatusThunk({ status: TxStatus.WAIT_USER_CONFIRM_TX, type }));
  let hasTxHash = false;
  try {
    emit.on("transactionHash", (hash) => {
      dispatch(updateTxStatus({ id, txHash: hash, status: TxStatus.TX_EXECUTING }));
      hasTxHash = true;
    });
    emit.on("receipt", () => {
      dispatch(updateTxStatus({ id, status: TxStatus.TX_SUCCESS }));
      setTimeout(() => {
        dispatch(popTxStatus({ id }));
      }, 15000);
    });
    emit.on("error", () => {
      if (hasTxHash) {
        dispatch(updateTxStatus({ id, status: TxStatus.TX_FAILED }));
        setTimeout(() => {
          dispatch(popTxStatus({ id }));
        }, 15000);
      } else dispatch(popTxStatus({ id }));
    });
  } catch (error) {
    console.error(error);
    dispatch(popTxStatus({ id }));
  }
}
